import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { enableMapSet } from 'immer';
import { App } from '@/app/App';
import { initMonitoring } from '@/shared/lib/monitoring';
import '@/shared/styles/global.css';

enableMapSet();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root was not found.');
}

initMonitoring();

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
